import { Components, Theme } from '@mui/material';

export const MuiTable: Components<Theme>['MuiTable'] = {
  defaultProps: {
    size: 'small',
  },
  styleOverrides: {
    root: ({ theme }) => {
      if (theme.featureFlags.panwRebrandStubYear) {
        return {
          borderColor: theme.palette.border.default,
        };
      }

      return {};
    },
  },
};
